/* @flow */

import * as selectors from './products-selectors';

export const Products = {
    ...selectors,
};
